export const BrandLockup = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-lockup">
    <img
      src="/logos/ift.png"
      alt="Grupo IFT"
      data-testid="ift-logo"
      className={`w-auto object-contain ${compact ? "h-8" : "h-11"}`}
    />
    <span className="divider-pulse h-6 w-px bg-[#34d186]/70 shadow-[0_0_12px_rgba(52,209,134,0.8)]" />
    <img
      src="/logos/bolt.png"
      alt="Bolt"
      data-testid="bolt-logo"
      className={`w-auto object-contain ${compact ? "h-5" : "h-6"}`}
    />
  </div>
);
